import { Star } from "@phosphor-icons/react";

/* ============================================================================
 * ReviewsSection — App Store reviews (public iTunes RSS feed).
 * ==========================================================================*/
export function ReviewsSection({ reviews }) {
  if (!reviews) return null;
  if (!reviews.configured) {
    return null; // silently hide if no APPLE_APP_ID
  }

  const average = reviews.average ?? 0;
  const count = reviews.count ?? 0;
  const items = reviews.reviews ?? [];
  const err = reviews.error;

  return (
    <section
      className="border border-white/10 bg-[#0a0a0a] p-6"
      data-testid="admin-reviews"
    >
      <div className="flex items-baseline justify-between mb-5 gap-3">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#FF2A2A] mb-1">
            // app store reviews
          </div>
          <h3 className="font-display text-xl font-extrabold tracking-tight">
            What people are saying
          </h3>
        </div>
        <div className="flex items-baseline gap-2">
          <div className="font-display text-3xl font-extrabold tracking-tight text-white">
            {average.toFixed(1)}
          </div>
          <div className="flex items-center gap-0.5">
            {Array.from({ length: 5 }, (_, i) => (
              <Star
                key={i}
                size={14}
                weight={i < Math.round(average) ? "fill" : "regular"}
                className={i < Math.round(average) ? "text-[#FF2A2A]" : "text-white/20"}
              />
            ))}
          </div>
          <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/45 ml-2">
            {count} recent
          </span>
        </div>
      </div>

      {err && (
        <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#FF2A2A]/80">
          couldn&apos;t load reviews · {err}
        </p>
      )}

      {!err && items.length === 0 && (
        <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/30">
          no reviews yet · apple takes a few days to index new ones
        </p>
      )}

      {items.length > 0 && (
        <ul className="space-y-4 max-h-[420px] overflow-y-auto pr-2">
          {items.map((r, idx) => (
            <li
              key={`${r.author}-${idx}`}
              data-testid={`review-${idx}`}
              className="border-l-2 border-[#FF2A2A]/40 pl-4 py-1"
            >
              <div className="flex items-baseline justify-between gap-3 mb-1.5">
                <div className="flex items-center gap-1">
                  {Array.from({ length: 5 }, (_, i) => (
                    <Star
                      key={i}
                      size={11}
                      weight={i < r.rating ? "fill" : "regular"}
                      className={i < r.rating ? "text-[#FF2A2A]" : "text-white/15"}
                    />
                  ))}
                  {r.title && (
                    <span className="ml-2 text-sm text-white/90 font-semibold">
                      {r.title}
                    </span>
                  )}
                </div>
                <span className="font-mono text-[9px] uppercase tracking-[0.18em] text-white/40 shrink-0">
                  {r.author} {r.version && `· v${r.version}`}
                </span>
              </div>
              <p className="text-sm text-white/70 leading-relaxed whitespace-pre-wrap">
                {r.content}
              </p>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
